import { Field, InjectedFormProps, reduxForm } from 'redux-form';

import DateInputField from 'dashboard/components/FormControls/DateInputField';
import InputField from 'dashboard/components/FormControls/InputField';
import Form from 'dashboard/layouts/FormLayout/Form';
import FormSection from 'dashboard/layouts/FormLayout/Section';
import Button from 'design-system/components/Button';
import { HStack } from 'design-system/components/Stack';
import PiiAttributes from 'lib/interfaces/PiiAttributes';
import { isMaxLength, isRequired, isValidDate, withMessage } from 'lib/utils/formValidation';

const validate = {
  'reference-id': [
    withMessage('Please limit your Reference ID to 255 characters', isMaxLength(255)),
  ],
  [PiiAttributes.NameLast]: [withMessage('Please enter a last name', isRequired)],
  [PiiAttributes.Birthdate]: [withMessage('Enter a valid date', isValidDate)],
};

interface FormCreateReportSecActionLookupProps {
  hideReferenceId: boolean;
  handleCancel: () => void;
  readOnly?: boolean;
}

const FormCreateReportSecActionLookup = ({
  submitting,
  hideReferenceId,
  handleSubmit,
  handleCancel,
  readOnly,
}: FormCreateReportSecActionLookupProps &
  InjectedFormProps<FormCreateReportSecActionLookupData, FormCreateReportSecActionLookupProps>) => {
  return (
    <Form onSubmit={handleSubmit}>
      {!hideReferenceId && (
        <Field
          id='create-report-sec-action-lookup__reference-id'
          label='Reference ID (Optional)'
          name='reference-id'
          disabled={submitting || readOnly}
          component={InputField}
          validate={validate['reference-id']}
          data-test='create-report-sec-action-lookup__reference-id'
        />
      )}
      <FormSection cols={2}>
        <Field
          id='create-report-sec-action-lookup__name-first'
          label='First name (Optional)'
          name={PiiAttributes.NameFirst}
          disabled={submitting || readOnly}
          type='text'
          component={InputField}
          placeholder='First name'
          data-test='create-report-sec-action-lookup__name-first'
        />
        <Field
          id='create-report-sec-action-lookup__name-last'
          label='Last name'
          name={PiiAttributes.NameLast}
          type='text'
          disabled={submitting || readOnly}
          component={InputField}
          validate={validate[PiiAttributes.NameLast]}
          placeholder='Last name'
          data-test='create-report-sec-action-lookup__name-last'
        />
      </FormSection>
      <Field
        id='create-report-sec-action-lookup__birthdate'
        label='Birthdate (Optional)'
        name={PiiAttributes.Birthdate}
        type='text'
        disabled={submitting || readOnly}
        component={DateInputField}
        validate={validate[PiiAttributes.Birthdate]}
        data-test='create-report-sec-action-lookup__birthdate'
      />
      <HStack equal={true}>
        <Button
          variant='basic'
          id='create-report-sec-action-lookup__cancel'
          data-test='create-report-sec-action-lookup__cancel'
          disabled={submitting}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          type='submit'
          data-test='create-report-sec-action-lookup__submit'
          disabled={submitting}
          isPending={submitting}
        >
          Create Report
        </Button>
      </HStack>
    </Form>
  );
};

export interface FormCreateReportSecActionLookupData {
  'reference-id'?: string;
  [PiiAttributes.NameFirst]?: string;
  [PiiAttributes.NameLast]?: string;
  [PiiAttributes.Birthdate]?: string;
}

export const FORM_CREATE_REPORT_SEC_ACTION_LOOKUP_NAME = 'formCreateReportSecActionLookupData';

export default reduxForm<FormCreateReportSecActionLookupData, FormCreateReportSecActionLookupProps>(
  {
    form: FORM_CREATE_REPORT_SEC_ACTION_LOOKUP_NAME,
  },
)(FormCreateReportSecActionLookup);
